import { Injectable } from '@angular/core';
import * as i0 from "@angular/core";
export class DataTableUtils {
    exportRow(row, columns, rendered) {
        const newRow = {};
        columns
            .filter((col) => col.displayed)
            .forEach((col) => {
            newRow[col.property] = this.retrieveCell(row, col, rendered);
        });
        return newRow;
    }
    retrieveCell(row, column, rendered = true) {
        const cell = this.findValue(row, column.property);
        if (column.pipe && rendered) {
            return this.applyPipe(column.pipe, cell, column.pipeArgs, column.pipeConstructorArgs);
        }
        return cell;
    }
    applyPipe(pipe, cell, pipeArgs = [], pipeConstructorArgs = []) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        const pipeInstance = new pipe(...pipeConstructorArgs);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        return pipeInstance.transform(cell, ...pipeArgs);
    }
    filter(items, cols, columnFiltering, filterText) {
        return items.filter((row) => {
            let found = false;
            if (columnFiltering && this.hasFilter(cols)) {
                let rowFound = false;
                // Not using forEach here because we needed to break when a false match occurs during column filtering
                for (const col of cols) {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                    const value = this.retrieveCell(row, col) + '';
                    const search = col.filter ? col.filter : '';
                    if (search.length > 0) {
                        if (value && value.toLowerCase().indexOf(search.toLowerCase()) !== -1) {
                            rowFound = true;
                        }
                        else {
                            rowFound = false;
                            break;
                        }
                    }
                }
                found = rowFound;
            }
            else if (columnFiltering && !this.hasFilter(cols)) {
                return true;
            }
            else if (filterText) {
                cols.forEach((col) => {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                    const value = this.retrieveCell(row, col) + '';
                    if (filterText && value && value.toLowerCase().indexOf(filterText.toLowerCase()) !== -1) {
                        found = true;
                    }
                });
            }
            return found;
        });
    }
    findValue(input, key) {
        const arr = key.split('.');
        while (arr.length) {
            const i = arr.shift();
            if (i !== undefined) {
                input = input[i];
            }
        }
        return input;
    }
    hasFilter(cols) {
        return cols.filter((col) => col.filter && col.filter.length > 0).length > 0;
    }
}
DataTableUtils.ɵfac = function DataTableUtils_Factory(t) { return new (t || DataTableUtils)(); };
DataTableUtils.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DataTableUtils, factory: DataTableUtils.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataTableUtils, [{
        type: Injectable
    }], null, null); })();
